<template>
	<!-- <tbody
		v-for="(estimationPart,
		index) in showEstimations"
		:key="estimationPart.id"
		:class="{
			'text-red':
				estimationPart.sparepart_type == 'P' &&
				!estimationPart.is_arrived,
			'bg-date':
				curr_date !=
				moment(estimationPart.created_at).format(
					'Y-MM-DD'
				),
			'bg-lg-yellow': estimationPart.without_ppn,
			'bg-red-opac':
				estimationPart.sparepart_type == 'P' &&
				supplierPriceList[estimationPart.id]
					.supplier_prices.length < 2,
		}"
	>
		<tr v-if="estimationPart.deleted_at == null || !(showHide)">
			<td
				v-if="estimationPart.deleted_at"
				colspan="20"
				style="color:red;font-weight:bold"
			>
				Estimasi Telah Dibatalkan
			</td>
			<template v-else>
				<td
					colspan="7"
					class="text-left"
					v-if="estimationPart.sparepart_type == 'P'"
				>
					<b
						>Status Barang :
						{{
							estimationPart.is_used
								? `Barang Sudah Terpakai`
								: estimationPart.is_arrived
								? `Barang Datang Pada Waktu 
								${moment(
										estimationPart.time
									).format("MMM DD, Y HH:mm")}`
								: estimationPart.is_po
								? `Barang Sudah Di Pesan`
								: `Barang Belum Dipesan`
						}}</b
					>
					
					
				</td>
				<td
					:colspan="
						estimationPart.sparepart_type == 'P'
							? 3
							: 10
					"
					class="text-right"
				>
					<b>{{
						moment(
							estimationPart.created_at
						).format("DD MMM Y HH:mm")
					}}</b>
				</td>
			</template>
		</tr>
		<tr 
			v-if="estimationPart.deleted_at == null || !(showHide)"
			:class="{
				cancelled: estimationPart.deleted_at != null,
			}"
		>
			<td>{{ index + 1 }}</td>
			<td>{{ estimationPart.sparepart_type }}</td>

			<td v-if="estimationPart.type">
				<Multiselect
					:disabled="statusText.find(x => x.name == 'Selesai').value != '-'"
					:options="['G/C', 'R/C', 'Special Repair']"
					v-model="estimationPart.type"
					:allow-empty="false"
				/>
			</td>
			<td v-else>-</td>
			<td>
				{{ estimationPart.alias }} {{ estimationPart.extension ? '- ' + estimationPart.extension : '' }} 
				<button
					class="ml-3 btn btn-secondary"
					v-if="!estimationPart.image"
					name="Tambah Gambar"
					@click="addImage(estimationPart)"
				>
					+ Gambar
				</button>
				<button
					class="ml-3 btn btn-outline-secondary"
					v-else
					name="Preview Image"
					@click="
						previewImage(estimationPart.image)
					"
				>
					Lihat Gambar
				</button>
				
			</td>

			<td style="min-width:200px">
				<textarea 
					type="text"
					cols="2"
					class="form-control"
					v-model="estimationPart.part_number"
					:disabled="statusText.find(x => x.name == 'Selesai').value != '-'"
				/>
			</td>



			<td
				v-if="estimationPart.supplier_price_id"
				style="width:200px;!important"
			>
				<div class="row ">
					<div class="mt-2 col">
						Rp
						{{
							numberWithCommas(
								parseFloat(
									estimationPart.price_per_item
								)
							)
						}}
					</div>
					<div
						class="col"
						v-if="
							estimationPart.sparepart_type !=
								'J' 
						"
					>
						<button
							class="btn btn-outline-danger w-100"
							@click="
								estimationPart.supplier_price_id = null
							"
						>
							Batal
						</button>
					</div>
				</div>
			</td>
			<td
				v-else-if="
					estimationPart.sparepart_type == 'P' &&
						supplierPriceList &&
						supplierPriceList[estimationPart.id]
							.supplier_prices.length > 1 &&
						!estimationPart.is_supplied_by_insurance
				"
			>
				<template>
					<button
						type="button"
						class="btn btn-info mb-1"
						@click="
							showPriceModal(
								estimationPart.sparepart_type,
								supplierPriceList[
									estimationPart.id
								],
								index,
								estimationPart.id
							)
						"
					>
						Pilih Harga
					</button>
				</template>
			</td>
			<td
				v-else-if="
					estimationPart.sparepart_type == 'J' &&
						supplierPriceList &&
						supplierPriceList[estimationPart.id]
							.supplier_prices.length == 1 &&
						!estimationPart.is_supplied_by_insurance
				"
			>
				<template>
					<button
						type="button"
						class="btn btn-info mb-1"
						@click="
							showPriceModal(
								estimationPart.sparepart_type,
								supplierPriceList[
									estimationPart.id
								],
								index,
								estimationPart.id
							)
						"
					>
						Pilih Harga
					</button>
				</template>
			</td>
			<td
				v-else-if="
					estimationPart.sparepart_type == 'P' &&
						supplierPriceList &&
						supplierPriceList[estimationPart.id]
							.supplier_prices.length <= 1 &&
						!estimationPart.is_supplied_by_insurance
				"
			>
				<template>
					<button
						type="button"
						class="btn btn-warning mb-1"
						@click="
							$router.push({
								name:
									'EstimatorSparepartDetail',
								params: { id: form_code },
							})
						"
						:disabled="
							estimationPart.deleted_at != null
						"
					>
						Ke Parts Quotation
					</button>
				</template>
			</td>
			<td
				v-else-if="
					estimationPart.is_supplied_by_insurance
				"
			>
				Rp 0
			</td>
			<td v-else>Rp -</td>

			<td>{{ estimationPart.amount }}</td>
			<td>
				Rp
				{{
					estimationPart.price_per_item > 0
						? numberWithCommas(
								estimationPart.amount *
									parseInt(
										estimationPart.price_per_item
									)
							)
						: "-"
				}}
			</td>
			<td
				v-if="
					estimationPart.is_approved_by_insurance ==
						null && showNegoInput[index] == false
				"
				style="min-width:300px"
			>
				<div class="row">
					<div
						class="col-12 mt-1"
						:class="{
							'col-md-6':
								estimationPart.sparepart_type !=
								'J',
						}"
					>
						<button
							class="btn btn-outline-success mr-1 w-100"
							@click="
								selectSPK(
									'Approved',
									index,
									estimationPart.id
								)
							"
							:disabled="
								estimationPart.deleted_at !=
									null
							"
						>
							Menyetujui
						</button>
					</div>
					<div
						class="col-12 mt-1 col-md-6"
						v-if="
							estimationPart.sparepart_type != 'J'
						"
					>
						<button
							class="btn btn-outline-primary mr-1 w-100"
							@click="
								selectSPK(
									'Supplied',
									index,
									estimationPart.id
								)
							"
							:disabled="
								estimationPart.deleted_at !=
									null
							"
						>
							Disediakan
						</button>
					</div>
					<div class="col-md-6 col-12 mt-1">
						<button
							class="btn btn-outline-warning mr-1 w-100"
							@click="showNego(index, true)"
							:disabled="
								estimationPart.deleted_at !=
									null
							"
						>
							Nego
						</button>
					</div>
					<div class="col-md-6 col-12 mt-1">
						<button
							class="btn btn-outline-danger mr-1 w-100"
							@click="
								selectSPK(
									'Reject',
									index,
									estimationPart.id
								)
							"
							:disabled="
								estimationPart.deleted_at !=
									null
							"
						>
							Ditolak
						</button>
					</div>
				</div>
			</td>
			<td
				v-else-if="showNegoInput[index] == true"
				style="width:400px!important"
			>
				<div class="row w-100">
					<div class="col-6">
						<label>Price Per Item</label>
						<input
							class="form-control"
							placeholder="Input Price Here"
							type="number"
							v-model="itemPrice"
						/>
					</div>
					<div class="col-6">
						<label>Markup Price</label>
						<input
							class="form-control"
							placeholder="Input Price Here"
							type="number"
							v-model="markupPrice"
						/>
					</div>
				</div>
				<br />
				<div class="row row-space">
					<div
						class="form-check form-check-inline col-5"
					>
						<input
							:disabled="withoutPPN"
							class="form-check-input"
							style="width:20%"
							type="checkbox"
							id="inlineCheckbox1"
							value="option1"
							v-model="ppnNego"
						/>
						<label
							class="form-check-label"
							for="inlineCheckbox1"
							>Termasuk PPN</label
						>
						<input
							class="form-check-input ml-1"
							style="width:20%"
							type="checkbox"
							id="inlineCheckbox1"
							value="option1"
							v-model="withoutPPN"
						/>
						<label
							class="form-check-label"
							for="inlineCheckbox1"
							>Tanpa PPN</label
						>
					</div>
					<div class="col-3">
						<button
							class="btn btn-outline-primary w-100"
							@click="
								updatePriceEstimation(
									'Nego',
									index,
									itemPrice,
									estimationPart.id
								)
							"
						>
							Nego
						</button>
					</div>
					<div class="col-3">
						<button
							class="btn btn-outline-danger w-100"
							@click="showNego(index, false)"
						>
							Batal
						</button>
					</div>
				</div>
			</td>
			<td v-else>
				<div class="row">
					<div
						class="col-md-6 col-12 mt-auto mb-auto"
					>
						<span
							style="color:blue"
							v-if="
								estimationPart.is_supplied_by_insurance ==
									1
							"
						>
							Disediakan Oleh Asuransi
							<br />
							<span
								>(
								{{
									estimationPart.estimation_status_change
										? moment(
												estimationPart.estimation_status_change
											).format(
												"MMM DD Y, HH:mm"
											)
										: "-"
								}}
								)</span
							>
						</span>
						<span
							style="color:green"
							v-else-if="
								estimationPart.is_approved_by_insurance ==
									1
							"
						>
							Disetujui
							<br />
							<span
								>(
								{{
									estimationPart.estimation_status_change
										? moment(
												estimationPart.estimation_status_change
											).format(
												"MMM DD Y, HH:mm"
											)
										: "-"
								}}
								)</span
							>
						</span>
						<span style="color:red" v-else>
							Ditolak
							<br />
							<span
								>(
								{{
									estimationPart.estimation_status_change
										? moment(
												estimationPart.estimation_status_change
											).format(
												"MMM DD Y, HH:mm"
											)
										: "-"
								}}
								)</span
							>
						</span>
					</div>
					<div class="col-md-6 col-12 mt-1">
						<button
							class="btn btn-outline-warning mr-1 w-100"
							@click="showNego(index, true)"
							:disabled="
								estimationPart.deleted_at !=
									null
							"
						>
							Nego
						</button>
					</div>
				</div>
			</td>
			<td>
				<button
					class="btn btn-danger"
					@click="
						deleteEstimations(estimationPart.id)
					"
					v-if="
						!statusText.find(
							(x) =>
								x.name == 'Penawaran' &&
								x.value != '-'
						)
					"
					:disabled="
						estimationPart.deleted_at != null
					"
				>
					<i class="fa fa-times-circle"></i>
				</button>
			</td>
		</tr>
	</tbody> -->
	<div class="pl-3 pr-3 pt-2 pb-2 body-estimation" style="border-bottom: 1px solid black" :class="{'blur' : estimationPart.deleted_at}">
		<div class="row ">
			<div class="col-6">
				<div
					colspan="7"
					class="text-left"
					v-if="estimationPart.deleted_at"
				>
					Estimasi Telah Dibatalkan
					
					
				</div>
				<div
					colspan="7"
					class="text-left"
					v-else-if="estimationPart.sparepart_type == 'P'"
				>
					<b
						>Status Barang :
						{{
							estimationPart.is_used
								? `Terpakai ${estimationPart.is_used_date ? `di tanggal ${moment(
										estimationPart.is_used_date
									).format("MMM DD, Y")}` : ''}`
								: estimationPart.is_arrived
								? `Barang Datang Pada Waktu 
								${moment(
										estimationPart.time
									).format("MMM DD, Y HH:mm")}`
								: estimationPart.is_po
								? `Barang Sudah Di Pesan`
								: `Barang Belum Dipesan`
						}}</b
					>
					
					
				</div>
				
			</div>
			<div class="col-6">
				<div
					colspan="7"
					class="text-right"
				
				>
					<b>{{
						moment(
							estimationPart.created_at
						).format("DD MMM Y HH:mm")
					}}</b>
					
					
				</div>
			</div>
		</div>
		<div class="">
			<div class="row mt-3">
				<div class="col-6 row">
					<div class="col-4">
						<b>Tipe</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7">
						{{dictionary.find(x => x.type == estimationPart.sparepart_type).name}} {{estimationPart.type ? ` (Tipe Jasa : ${estimationPart.type}) ` : ''}}
					</div>
					 
				</div>
				<div class="col-6 row">
					<div class="col-4">
						<b>Jumlah</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7">
						{{estimationPart.amount}}
					</div>
					 
				</div>
				
				
				
			</div>

			<div class="row mt-2">
				<div class="col-6 row">
					<div class="col-4">
						<b>Nama Sparepart</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7">
						{{ estimationPart.alias }} {{ estimationPart.extension ? '- ' + estimationPart.extension : '' }} 
					</div>
					<!-- {{estimationPart}} -->
					 
				</div>
				<div class="col-6 row">
					<div class="col-4">
						<b>Harga / Item</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7" v-if="estimationPart.price_per_item">
						Rp
						{{
							numberWithCommas(
								parseFloat(
									estimationPart.price_per_item
								)
							)
						}}

						{{
							(estimationPart.sparepart_type == 'P' && !estimationPart.is_approved_by_insurance) ? '(Harga Sementara)' : ''
						}}
					</div>
					<div class="col-7" v-else>
						Rp -
					</div>
					 
				</div>
				
				
			</div>

			<div class="row mt-2">
				<div class="col-6 row">
					<div class="col-4 mt-auto mb-auto">
						<b>Deskripsi</b>
					</div>
					<div class="col-1 mt-auto mb-auto">
						:
					</div>
					<div class="col-7">
						<span v-if="!editEstimation" >{{ estimationPart.part_number }} </span>
						<input type="text"  v-else v-model="estimationPart.part_number" class="form-control input--style-4" /> <i v-if="!editEstimation" @click="editEstimation = !editEstimation" class="fa fa-edit"></i>
					</div>
					 
				</div>
				<div class="col-6 row" v-if="estimationPart.sparepart_type == 'P'">
					<div class="col-4">
						<b>Markup</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7">
						Rp
						{{
							numberWithCommas(
								parseFloat(
									estimationPart.markup ? estimationPart.markup : 0
								)
							)
						}}
					</div>
					 
				</div>
				<div class="col-6 row" v-else-if="showSupplyApply">
					<div class="col-4">
						<b>Supply Apply</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7">
						Rp
						{{
							numberWithCommas(
								parseFloat(
									estimationPart.modal_jasa ? estimationPart.modal_jasa : 0
								)
							)
						}}
					</div>
					 
				</div>
				
				
				
			</div>

			<div class="row mt-2">
				<div class="col-6 row">
					<div class="col-4">
						<b>Status Asuransi</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7">
						<span
							style="color:blue"
							v-if="
								estimationPart.is_supplied_by_insurance ==
									1
							"
						>
							Disediakan Oleh Asuransi
							<span
								>(
								{{
									estimationPart.estimation_status_change
										? moment(
												estimationPart.estimation_status_change
											).format(
												"MMM DD Y, HH:mm"
											)
										: "-"
								}}
							)</span
							>
						</span>
						<span
							style="color:green"
							v-else-if="
								estimationPart.is_approved_by_insurance ==
									1
							"
						>
							Disetujui
							<span
								>(
								{{
									estimationPart.estimation_status_change
										? moment(
												estimationPart.estimation_status_change
											).format(
												"MMM DD Y, HH:mm"
											)
										: "-"
								}}
								)</span
							>
						</span>
						<span style="color:red" v-else-if="typeof estimationPart.is_approved_by_insurance == 'number' && estimationPart.is_approved_by_insurance == 0">
							Ditolak
							<span
								>(
								{{
									estimationPart.estimation_status_change
										? moment(
												estimationPart.estimation_status_change
											).format(
												"MMM DD Y, HH:mm"
											)
										: "-"
								}}
								)</span
							>
						</span>
						<span v-else>
							Belum Terpilih
						</span>
					</div>
					
				</div>

				<div class="col-6 row">
					<div class="col-4">
						<b>PPN</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7" v-if="estimationPart.individual_ppn">
						Rp
						{{
							numberWithCommas(
								parseFloat(
									estimationPart.individual_ppn
								)
							)
						}}
					</div>
					<div class="col-7" v-else>
						Rp -
					</div>
					 
				</div>
				
			</div>

			<div class="row mt-2" v-if="estimationPart.sparepart_type == 'P'">
				<div class="col-md-6 row">
					<div class="col-4">
						<b>Supplier</b>
					</div>
					<div class="col-1">
						:
					</div>
					<div class="col-7" v-if="estimationPart.supplier_name">
						{{estimationPart.supplier_name}}
					</div>
					<div class="col-7" v-else>
						- {{estimationPart.is_supplied_by_insurance ? '(Belum Diketahui)' : ''}}
					</div>
				</div>
			</div>

			<div class="row mt-3">
				<div class="col-8">
					<b>Total Harga</b>
				</div>
				<div class="col-4 row text-right">
					<div class="col-4">
						
					</div>
					<div class="col-8">
						<b>Rp
							<!-- {{estimationPart.markup}} -->
						{{
							estimationPart.price_per_item > 0
								? numberWithCommas(
										estimationPart.amount *
											(parseInt(
												estimationPart.price_per_item
											) + parseFloat(estimationPart.markup ? estimationPart.markup : 0) + parseFloat(estimationPart.individual_ppn ? estimationPart.individual_ppn : 0) )
									)
								: "-"
						}}</b>
					</div>
					 
				</div>
				
			</div>
			<hr v-if="showNegoInput" >
			<div class="row mt-3 pr-3" v-if="showNegoInput" style="color:black">
				
				<div class="col-12 rounded">
					<h5>Nego Harga Estimasi</h5>
					<table class="table table-bordered">
						<thead>
							<th>Harga Modal</th>
						</thead>
						<tbody>
							<tr>
								<td>Rp. {{numberWithCommas(estimationPart.price_per_item ? estimationPart.price_per_item : estimationPart.price_modal)}}</td>
							</tr>
						</tbody>
					</table>
					<div class="row" v-if="estimationPart.sparepart_type == 'P'">
						<div class="col-4 mt-auto mb-auto">
							Isi Harga Yang Akan Ditagih
						</div>
						<div class="col-1 mt-auto mb-auto">
							:
						</div>
						<div class="col-7">
							<input type="text" class="form-control" v-model="negoPrice"/>
						</div>
						<div class="row row-space col-12 mt-2">
							<div
								class="form-check form-check-inline col-4 offset-9"
							>
								<input
									class="form-check-input ml-1"
									style="width:20%"
									type="checkbox"
									id="inlineCheckbox2"
									value="option1"
									v-model="tambahPPN"
								/>
								<label
									class="form-check-label"
									for="inlineCheckbox1"
									>Tambah PPN</label
								>
							</div>
						</div>
					</div>
					<div class="row" v-else>
						<div class="col-4 mt-auto mb-auto">
							Update Harga Jasa
						</div>
						<div class="col-1 mt-auto mb-auto">
							:
						</div>
						<div class="col-7">
							<input type="text" class="form-control" v-model="negoPrice"/>
						</div>
						<div class="row row-space col-12 mt-2">
							<div
								class="form-check form-check-inline col-5 offset-7"
							>
								<input
									:disabled="withoutPPN"
									class="form-check-input"
									style="width:20%"
									type="checkbox"
									id="inlineCheckbox1"
									value="option1"
									v-model="ppnNego"
								/>
								<label
									class="form-check-label"
									for="inlineCheckbox1"
									>Termasuk PPN</label
								>
								<input
									class="form-check-input ml-1"
									style="width:20%"
									type="checkbox"
									id="inlineCheckbox1"
									value="option1"
									v-model="withoutPPN"
								/>
								<label
									class="form-check-label"
									for="inlineCheckbox1"
									>Tanpa PPN</label
								>
							</div>
						</div>
					</div>
					<div class="text-right mt-3">
						<button class="btn btn-primary" v-if="estimationPart.sparepart_type == 'J'" @click="updatePriceEstimation('Nego' , 0 , estimationPart.id)">Nego Selesai</button>
						<button class="btn btn-primary" v-else @click="updateNegoPart">Nego Selesai</button>
						<button class="btn btn-danger ml-4" @click="showNegoInput = false">Batal Nego</button>
					</div>
				</div>
				
				
			</div>
			<hr v-if="showNegoInput" >

			<div v-if="editEstimation" class="mt-3 mb-3 ">
				<button
					class="btn btn-outline-success btn-lg"
					@click="
						saveChanges
					"
				>
					Simpan ke Sistem
				</button>
				<button
					class="btn btn-outline-danger btn-lg ml-3"
					@click="
						editEstimation = false
					"
				>
					Batal
				</button>
			</div>
			<hr>

			<div class="row mt-1" v-if="!estimationPart.deleted_at">
				<div class="col-lg-6 col-12 pl-4 pr-4 mt-2" v-if="
					typeof estimationPart.is_approved_by_insurance != 'number' && !noEstimation
				">
					<div class="text-center mb-1" style="color:black;font-weight:bold">Status Estimasi</div>
					<div class="row rounded p-10">
						<div
							class="col mt-1"
						>
							<button
								class="btn btn-success mr-1 w-100"
								@click="
									selectSPK(
										'Approved',
										index,
										estimationPart.id
									)
								"
								:disabled="
									estimationPart.deleted_at !=
										null
								"
							>
								Menyetujui
							</button>
						</div>
						<div
							class="col mt-1"
							v-if="
								estimationPart.sparepart_type != 'J'
							"
						>
							<button
								class="btn btn-primary mr-1 w-100"
								@click="
									selectSPK(
										'Supplied',
										index,
										estimationPart.id
									)
								"
								:disabled="
									estimationPart.deleted_at !=
										null
								"
							>
								Disediakan
							</button>
						</div>
						
						<div class="col mt-1">
							<button
								class="btn btn-danger mr-1 w-100"
								@click="
									selectSPK(
										'Reject',
										index,
										estimationPart.id
									)
								"
								:disabled="
									estimationPart.deleted_at !=
										null
								"
							>
								Ditolak
							</button>
						</div>
					</div>
				</div>

				<div class="col-lg-6 col-12 pl-4 pr-4 mt-2">
					<div class="text-center mb-1" style="color:black;font-weight:bold">Miscellaneous</div>
					<div class="row rounded p-10">
					
						<div
							class="col-lg-4 col-xs-6 mt-1"
							v-if="estimationPart.sparepart_type == 'P' && !noSetHarga"
							
						>
							<button
								type="button"
								class="btn btn-info mr-1 w-100"
								:disabled="(estimationPart.price_modal) || (estimationPart.is_approved_by_insurance)"
								@click="
									showPriceModal(
										estimationPart.sparepart_type,
										supplierPriceList[
											estimationPart.id
										],
										index,
										estimationPart.id
									)
								"
							>
								Set Harga
							</button>
						</div>
						<div
							class="col-lg-4 col-xs-6 mt-1"
							v-if="estimationPart.sparepart_type == 'P' && estimationPart.delivery_photo"
							
						>
							<!-- {{estimationPart.delivery_photo}} -->
							<button
								type="button"
								class="btn btn-outline-primary mr-1 w-100"
								@click="photo = estimationPart.delivery_photo.split(',')"
							>
								<i class="fa fa-camera"></i> Sparepart Baru
							</button>
						</div>
						<div class="col-lg-4 col-xs-6 mt-1" v-if="estimationPart.sparepart_type == 'P'">
							<button
								class="btn btn-secondary w-100"
								v-if="!estimationPart.image"
								name="Tambah Gambar"
								@click="$emit('addImage' , estimationPart)"
							>
								+ Foto Rusak
							</button>
							<button
								class="btn btn-outline-secondary w-100"
								v-else
								name="Preview Image"
								@click="photo = estimationPart.image.split(',')"
							>
								
								<i class="fa fa-camera"></i> Sparepart Rusak
							</button>
						</div>
						<div class="col-lg-4 col-xs-6 mt-1">
							<button
								class="btn btn-warning mr-1 w-100"
								@click="showNego"
								:disabled="
									estimationPart.deleted_at !=
										null
								"
							>
								{{ estimationPart.sparepart_type == 'J' ? 'Nego' : 'Isi Markup'}}
							</button>
						</div>
						<!-- <div class="col">
							<button
								class="btn btn-primary w-100"
								@click="
									editEstimation = !editEstimation
								"
							>
								Ubah
							</button>
						</div> -->
						<div class="col-lg-4 col-xs-6 mt-1">
							<button
								class="btn btn-danger w-100"
								@click="
									deleteEstimations(null , estimationPart.id)
								"
							
								:disabled="
									estimationPart.deleted_at != null
								"
							>
								Batalkan
							</button>
						</div>
						


					</div>
				</div>
				
			</div>

			
		</div>

		<adminAuth
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			:request="
				`Cancel Estimation For ${estimationPart.sparepart_name} - ${estimationPart.part_number}`
			"
			@approved="allowDeleteEstimations"
			@token="deleteEstimations"
		/>

		<preview-image
			v-if="photo.length > 0"
			@closeModal="photo = []"
			:image="photo"
		></preview-image>
	</div>
</template>

<script>
import moment from 'moment'
import AdminAuth from '@/components/modal/adminAuthorization'
import PreviewImage from '../../../../../components/modal/previewImage.vue'
export default {
	props : ['estimationPart' , 'supplierPriceList' , 'noEstimation' , 'noSetHarga' , 'showSupplyApply'],
	components : {
		AdminAuth,
		PreviewImage
	},
	data () {
		return {
			moment,
			reason : '',
			showNegoInput : false,
			negoPrice : 0,
			withoutPPN : false,
			ppnNego : false,
			tambahPPN : false,
			editEstimation : false,
			modal : {
				showAdminAuth : false
			},
			saved : {
				delete : {
					id : null
				}
			},
			dictionary : [{
				type : 'P',
				name : "Part"
			}, {
				type : 'O',
				name : 'Special Bahan'
			}, {
				type : 'J',
				name : 'Jasa'
			}],
			photo : []
		}
	},
	watch : {
		'negoPrice' : function () {
			const result = this.negoPrice.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.negoPrice = result);
		},
	},
	methods : {
		deleteEstimations(token = null , id = null) {
			let prevToken = "";
			if(id)
				this.saved.delete.id = id

			if (token) {
				prevToken = this.$http.defaults.headers.common["Authorization"];

				this.$http.defaults.headers.common["Authorization"] =
					"Bearer " + token;
			}

			this.$http
				.get("/api/v1/check")
				.then((resp) => {
					let data = resp.data.data;
					let super_user = data.is_superuser;

					if (super_user) {
						this.allowDeleteEstimations(token , prevToken , this.saved.delete.id);
					} else {
						this.modal.showAdminAuth = true;
						this.reason = token
							? "Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya."
							: "Untuk Memakai Fitur Batalkan Estimasi, Diperlukan Otorisasi Administrator.";
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		allowDeleteEstimations(token , prevToken , id) {
			this.modal.showAdminAuth = false;

			if (token) {
				this.$http.defaults.headers.common["Authorization"] = prevToken;
			}
			this.$store.dispatch("triggerAlert", [
				true,
				"Admin Permission Success",
			]);

			this.$emit('deleteEstimations' , id)
		},
		showPriceModal (
			sparepart_type,
			pricelist,
			index,
			id
		) {
			this.$emit('showPriceModal' , sparepart_type, pricelist, index, id)
		},
		showNego() {
			if(!this.estimationPart.supplier_price_id) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Pilih Harga Terlebih Dahulu'])
				return
			}
			this.negoPrice = 0;
			this.showNegoInput = true
		},
		selectSPK(
			status,
			index,
			id
		) {
			this.$emit('selectSPK' , status , index , id)
		},
		saveChanges() {
			// for (var i = 0; i < this.estimationData.estimations.length; i++) {
			let curEstimation = this.estimationPart;
			// let index = i;
			console.log(curEstimation)

			this.$http
				.patch("/api/v1/estimations/" + curEstimation.id, {
					type: curEstimation.type,
					part_number : curEstimation.part_number
				})
				.then((resp) => {

					this.$store.dispatch("triggerAlert", [
						true,
						"Changes have been saved.",
					]);
					this.editEstimation = false
				})
				.catch((err) => {
					console.log(err);
				});
			// }
		},
		updatePriceEstimation (status , index , id) {
			if(this.negoPrice == '') {
				this.$store.dispatch('triggerAlert' , [false , 'Nego Input harus di isi'])
				return
			}


			this.$emit('updatePriceEstimation', status , index , {
				price : this.negoPrice.split(',').join(''),
				withoutPPN : this.withoutPPN,
				ppnNego : this.ppnNego	
			} , id)
			// this.$emit('')
			this.showNegoInput = false
		},
		async updateNegoPart () {
			try {
				if(this.negoPrice == '') {
					this.$store.dispatch('triggerAlert' , [false , 'Nego Input harus di isi'])
					return
				}

				let ppn = this.tambahPPN
				let price = parseFloat(this.negoPrice.split(',').join(''))

				console.log(price , this.negoPrice)

				let markup = parseFloat(this.negoPrice.split(',').join('')) - parseFloat(this.estimationPart.price_modal ? this.estimationPart.price_modal : this.estimationPart.price_per_item)
				// let price = parseFloat(this.estimationPart.price_per_item + markup)

				console.log(markup)

				let response = await this.$http.patch('/api/v1/estimations/' + this.estimationPart.id, {ppn : ppn , markup : markup})

				// let response2 = await this.$http.patch('/api/v1/estimations-supplier/' + this.estimationPart.supplier_price_id , )

				let response3 = await this.$http.post("/api/v1/estimations/" + this.estimationPart.id + "/negotiation", {new_price: parseFloat(price)})

				this.$store.dispatch("triggerAlert", [true,[`Nego Berhasil Disimpan`]]);
				this.showNegoInput = false
				this.$emit('loadEstimation')

			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , err , 'Error : Something Went Wrong.'])
			}
			
		}

	}
}
</script>

<style scoped>
	.body-estimation {
		font-size: 14px;
		/* font-weight: bold; */
	}

	.blur {
		-webkit-filter: blur(2px);
		-moz-filter: blur(2px);
		-o-filter: blur(2px);
		-ms-filter: blur(2px);
		filter: blur(2px);
		/* width: 100px; */
		/* height: 100px; */
		background-color: #ccc;
	}
</style>